import { memo } from 'react';
import { useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';

import { loadBackOfficeUsers } from 'store/modules/backOfficeUsers/actions';

import { useBackOfficeUsersRequestParameters } from '../useBackOfficeRequestParameters';

function BackOfficeUsersRequest() {
  const parameters = useBackOfficeUsersRequestParameters();
  const dispatch = useDispatch();

  useDeepCompareEffect(() => {
    dispatch(loadBackOfficeUsers(parameters));
  }, [dispatch, parameters]);

  return null;
}

export default memo(BackOfficeUsersRequest);
